<script setup>
import { provide, ref } from 'vue'
import { num2k } from '@/utils'
import SharePanel from '../SharePanel/index.vue'

defineProps({
  size: { type: String, default: null },
  shareId: { type: [String, Number], default: null },
  isLike: { type: Boolean, default: false },
  likeNum: { type: Number, default: 0 },
  showBtn: { type: Boolean, default: true }
})

const popover2Ref = ref()
provide('popover2Ref', popover2Ref)
const backTop = () => {
  window.scroll({ behavior: 'smooth', top: 0, left: 0 })
}
</script>

<template>
  <div class="tvb-article-tool-bottom tvb-hairline--top">
    <div class="tvb-article-back-top" @click="backTop">
      <tvb-svg-icon name="icon_top_article" />
    </div>
    <template v-if="showBtn">
      <div class="tool-item" :class="{ selected: isLike }" @click="$emit('like')">
        <tvb-svg-icon
          class="tool-icon"
          :name="isLike ? 'icon_article_like_grey' : 'icon_article_like_default'"
        />
        <p class="tool-text">
          {{ likeNum ? num2k(likeNum) : '點讚' }}
        </p>
      </div>
      <n-popover
        ref="popover2Ref"
        class="tvb-article-share_popover-m"
        trigger="click"
        display-directive="show"
        :show-arrow="false"
        placement="top-end"
        :to="false"
      >
        <template #trigger>
          <div class="tool-item">
            <tvb-svg-icon class="tool-icon" name="icon_article_share_default" />
            <p class="tool-text">分享</p>
          </div>
        </template>
        <share-panel :size="size" :share-id="shareId"></share-panel>
      </n-popover>
    </template>
  </div>
</template>

<style lang="scss" scoped>
// 底部工具栏
.tvb-article-tool-bottom {
  background-color: #fff;
  position: fixed !important;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 44px;
  line-height: 44px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .tvb-article-back-top {
    width: 34px;
    height: 34px;
    font-size: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    cursor: pointer;
  }

  .tool-item {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 12px;
    cursor: pointer;

    .tool-icon {
      font-size: 24px;
      color: #888;
      margin-right: 4px;
      user-select: none;
    }

    .tool-text {
      font-size: 13px;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }

    &.selected {
      .tool-icon {
        color: #0062a3;
        --icon_article_like_grey: #0062a3 !important;
      }
      .tool-text {
        color: #0062a3;
      }
    }
  }
}

// 分享弹窗样式
:deep(.tvb-article-share_popover),
:deep(.tvb-article-share_popover-m) {
  --n-space: 12px !important;
  --n-padding: 0 !important;
  // --n-border-radius: 10px !important;
  --n-color: transparent !important;
  --n-box-shadow: none !important;
}
:deep(.tvb-article-share_popover-m) {
  --n-space: 6px !important;
  margin-right: var(--n-space);
}
</style>
